import type { ReactNode } from 'react';

export const symbol_carry_on_bag_checked: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m698-206-45-45q-5.6-6-14-6t-14.2 5.8q-5.8 5.8-5.8 14.2 0 8.4 6 14l52 52q9 9 21 9t21-9l106-107q6-5.6 6-14t-5.8-14.2q-5.8-5.8-14.2-5.8-8.4 0-14 6l-99 100Zm-340 11v-409h-66v409h66Zm-66 60q-24 0-42-18t-18-42v-409q0-24 18-42t42-18h281v-156h-54q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h84q12.75 0 21.38 8.62Q633-862.75 633-850v356q0 15-9.32 22.5t-20.5 7.5q-11.18 0-20.68-7.5T573-494v-110H418v409h32q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H292Zm570.5-237.5Q919-316 919-235T862.5-97.5Q806-41 725-41T587.5-97.5Q531-154 531-235t56.5-137.5Q644-429 725-429t137.5 56.5ZM388-400Zm-30 205v-409 409Zm60 0v-409 409Z"
		/>
	</svg>
);
